import React from 'react';

const AllergenIcon = ({ allergenId, size = 'sm', className = '' }) => {
  const iconMap = {
    wheat: '🌾',
    fish: '🐟',
    peanuts: '🥜',
    tree_nuts: '🌰',
    milk: '🥛',
    celery: '🥬',
    crustaceans: '🦐',
    eggs: '🥚',
    mustard: '🌶️',
    sesame: '🫘',
    mollusks: '🐚',
    lupin: '🌿',
    soybeans: '🫘',
    sulfites: '⚗️'
  };

  const sizeClasses = {
    xs: 'w-3 h-3 text-xs',
    sm: 'w-4 h-4 text-sm',
    md: 'w-5 h-5 text-base',
    lg: 'w-6 h-6 text-lg',
    xl: 'w-8 h-8 text-xl'
  };

  const icon = iconMap[allergenId] || '⚠️';
  const sizeClass = sizeClasses[size] || sizeClasses.sm;

  return (
    <span 
      className={`inline-flex items-center justify-center ${sizeClass} ${className}`}
      title={`Allergen: ${allergenId}`}
      role="img"
      aria-label={`Allergen: ${allergenId}`}
    >
      {icon}
    </span>
  );
};

export default AllergenIcon;
